import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { XCircle, AlertCircle } from 'lucide-react';
export function OldSolutions() {
  const failures = [{
    title: 'Reposo',
    desc: 'Baja el dolor momentáneamente, pero suele subir la rigidez y bajar la fuerza.'
  }, {
    title: 'Pomadas / Analgésicos',
    desc: 'Ayudan a pasar el día, pero no construyen soporte.'
  }, {
    title: 'Videos random',
    desc: 'Te pueden quedar grandes o chicos; no están hechos para TU semáforo.'
  }, {
    title: 'Exigirte',
    desc: 'Te da una falsa victoria hoy y te cobra mañana.'
  }];
  return <Section background="warm" data-id="element-261">
      <FadeIn data-id="element-262">
        <div className="mb-16" data-id="element-263">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-264">
            El problema no es tu carácter
          </h2>
          <p className="text-lg text-[#1A1A1A] leading-relaxed mb-6" data-id="element-265">
            Si probaste cosas y no funcionó, no es porque "no tenés constancia".
            Es porque te dieron ejercicios sueltos (sin progresión), rutinas
            largas (imposibles de sostener), o el clásico consejo que te deja
            solo/a: "movete más".
          </p>
          <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-r-lg" data-id="element-266">
            <p className="font-medium text-red-800" data-id="element-267">
              ¿Moverte más cómo? ¿Cuánto? ¿Hasta dónde? ¿Con qué dolor? Ahí es
              donde empieza la recaída.
            </p>
          </div>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-268">
        <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-269">
          Por qué lo viejo falla (aunque sea popular)
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-270">
          {failures.map((item, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-271">
              <div className="flex items-start mb-3" data-id="element-272">
                <XCircle className="h-6 w-6 text-red-400 mr-3 flex-shrink-0" data-id="element-273" />
                <h4 className="font-bold text-lg" data-id="element-274">{item.title}</h4>
              </div>
              <p className="text-gray-600 ml-9" data-id="element-275">{item.desc}</p>
            </div>)}
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-276">
        <div className="mt-16 bg-[#1B4332] text-white p-8 md:p-10 rounded-2xl text-center" data-id="element-277">
          <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-full mb-6" data-id="element-278">
            <AlertCircle className="h-8 w-8 text-[#D8F3DC]" data-id="element-279" />
          </div>
          <h3 className="text-2xl md:text-3xl font-serif font-bold mb-4" data-id="element-280">
            La verdad incómoda
          </h3>
          <p className="text-xl leading-relaxed text-[#D8F3DC]" data-id="element-281">
            Tu rodilla no necesita un día heroico. Necesita carga tolerable. La
            cantidad justa de estímulo para que el cuerpo diga: "ok, puedo
            sostener esto"… sin defenderse con inflamación.
          </p>
        </div>
      </FadeIn>
    </Section>;
}